import React, { useState } from "react";
import { BsArrowRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import axios from "../../Utilities/axios";
import lagosBg from "../../assets/lagos.jpg";
import abujaBg from "../../assets/abuja.jpg";
import enuguBg from "../../assets/enugu.jpg";
import anambraBg from "../../assets/anambra.png";
import "./Locations.css";

const locations = [
  {
    state: "Lagos",
    tagline: "The heartbeat of hospitality",
    hotels: 3,
    areas: "Lekki, Guzape, Ajao Estate",
    bg: lagosBg,
    size: "lg",
  },
  {
    state: "Abuja",
    tagline: "Where luxury meets the capital",
    hotels: 2,
    areas: "Area 11, Guzape",
    bg: abujaBg,
    size: "md",
  },
  {
    state: "Enugu",
    tagline: "The coal city's finest stay",
    hotels: 1,
    areas: "OGIDA",
    bg: enuguBg,
    size: "md",
  },
  {
    state: "Anambra",
    tagline: "The pride of the east",
    hotels: 1,
    areas: "Ogidi",
    bg: anambraBg,
    size: "md",
  },
];

const Locations = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(null);

  const handleExplore = async (stateName, bgImage) => {
    setLoading(stateName);
    try {
      const res = await axios.get(
        `/registrations/hotels?sourceType=showInCompanySite&hotelGroupName=Residency`,
      );
      const filtered = res.data.filter((hotel) =>
        hotel.location?.toLowerCase().includes(stateName.toLowerCase()) ||
        hotel.hotelName?.toLowerCase().includes(stateName.toLowerCase())
      );
      navigate("/availablehotels", {
        state: { availableHotel: filtered, stateName, bgImage },
      });
    } catch {
      navigate("/availablehotels", {
        state: { availableHotel: [], stateName, bgImage },
      });
    }
    setLoading(null);
  };

  return (
    <section className="locations">
      {/* ── Full Page Loader ── */}
      {loading && (
        <div className="locations__loader">
          <div className="locations__loader-content">
            <RotatingLines
              strokeColor="#ffffff"
              strokeWidth="4"
              animationDuration="0.75"
              width="64"
              visible={true}
            />
            <p className="locations__loader-text">Finding hotels in {loading}...</p>
          </div>
        </div>
      )}

      <div className="locations__container">
        {/* ── Header ── */}
        <div className="locations__header">
          <span className="locations__label">Our Presence</span>
          <h2 className="locations__heading">
            Where We{" "}
            <span className="locations__heading-accent">Are</span>
          </h2>
          <div className="locations__divider" />
          <p className="locations__desc">
            With over 10 branches across Nigeria, Residency Hotels is always
            close to wherever your journey takes you.
          </p>
        </div>

        {/* ── Bento Grid ── */}
        <div className="locations__bento">
          {locations.map((loc) => (
            <div
              className={`locations__card locations__card--${loc.size}`}
              key={loc.state}
              style={{ backgroundImage: `url(${loc.bg})` }}
            >
              <div className="locations__card-content">
                <p className="locations__card-welcome">Welcome to</p>
                <h3 className="locations__card-state">{loc.state}</h3>
                <p className="locations__card-tagline">{loc.tagline}</p>
                <p className="locations__card-areas">{loc.areas}</p>
                <button
                  className="locations__card-btn"
                  onClick={() => handleExplore(loc.state, loc.bg)}
                  disabled={loading === loc.state}
                >
                  {loading === loc.state ? "Loading..." : (
                    <>Explore <BsArrowRight /></>
                  )}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Bottom Wave ── */}
      <div className="locations__wave">
        <svg
          viewBox="0 0 1440 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <path
            d="M0,64L48,58.7C96,53,192,43,288,48C384,53,480,75,576,80C672,85,768,75,864,64C960,53,1056,43,1152,48C1248,53,1344,75,1392,85.3L1440,96L1440,120L0,120Z"
            fill="#F7F7FA"
          />
        </svg>
      </div>
    </section>
  );
};

export default Locations;
